var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVaildSubDomain)?_c('div',{attrs:{"id":"mainNavBar"}},[_c('span',{staticStyle:{"width":"100%"},domProps:{"innerHTML":_vm._s(_vm.headerPreview)}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da27bf02","hasScoped":false,"buble":{"transforms":{}}}!./src/components/homeModule/headerComponent/headerComponent.template.html
// module id = 298
// module chunks = 0